<mat-toolbar class="footer mat-elevation-z3">
  <div class="footer-section footer-activities">
    <span>Nos activités</span>
    <a href="https://www.keolis.com/fr/notre-offre/offre-transport/intermodalite" target="_blank">
      <mat-icon [svgIcon]="'bus-icon'"></mat-icon>
      <mat-icon [svgIcon]="'tram-icon'"></mat-icon>
      <mat-icon [svgIcon]="'bus-accessible-icon'"></mat-icon>
      <mat-icon [svgIcon]="'train-icon'"></mat-icon>
      <mat-icon [svgIcon]="'parking-icon'"></mat-icon>
      <mat-icon [svgIcon]="'voiture-icon'"></mat-icon>
      <mat-icon [svgIcon]="'velo-icon'"></mat-icon>
      <mat-icon [svgIcon]="'bateau-icon'"></mat-icon>
    </a>
  </div>
  <div class="footer-section footer-social-media">
    <span>Rester connecté</span>
    <a href="https://twitter.com/groupekeolis" target="_blank">
      <mat-icon [svgIcon]="'twitter-icon'"></mat-icon>
    </a>
    <a href="https://www.linkedin.com/company/26951" target="_blank">
      <mat-icon [svgIcon]="'linkedin-icon'"></mat-icon>
    </a>
    <a href="https://www.youtube.com/user/groupekeolis" target="_blank">
      <mat-icon [svgIcon]="'youtube-icon'"></mat-icon>
    </a>
    <a href="http://fr.slideshare.net/Keolis" target="_blank">
      <mat-icon [svgIcon]="'slideshare-icon'"></mat-icon>
    </a>
  </div>
  <div class="footer-section footer-contact">
    <a href="mailto:support-kivia@keolis.com"><span>CONTACT</span></a>
    <span class="bar">|</span>
    <a href="https://keoline.easyvista.com" target="_blank"><span>ASSISTANCE</span></a>
    <span class="bar">|</span>
    <a href="https://www.keolis.com/" target="_blank">
      <img alt="Keolis Logo" src="assets/logo_keolis.png"/>
    </a>
  </div>
</mat-toolbar>
